// =====================================================================
// CENTRAL CONTENT FILE — Radiografía de Negocio · Enrique Torres / Mr. ET
// Update copy, links and video URLs here. Everything is consumed by
// components in /src/components/landing.
// =====================================================================

const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const VIDEOS = {
  // Hero: business desk moving from chaos to order through a golden scan
  hero: `${PUBLIC_URL}/videos/hero-radiografia-caos-orden.mp4`,
  // Philosophy: chaos transformed through a golden tunnel
  philosophy: `${PUBLIC_URL}/videos/filosofia-ia-proceso-transformacion.mp4`,
  // Method/Results: premium 3D dashboard with business control panels
  method: `${PUBLIC_URL}/videos/metodo-dashboard-control.mp4`,
};

export const LINKS = {
  home: "https://enriquetorres.pro/",
  about: "https://enriquetorres.pro/quien-es-enrique-torres/",
  method: "https://enriquetorres.pro/metodo/",
  blog: "https://enriquetorres.pro/blog/",
  radio: "https://enriquetorres.pro/radio-onda-cero/",
  lab: "https://enriquetorres.pro/laboratorio-ia/",
};

export const PRICE_SECTION_LINK = "#precio";
export const CHECKOUT_RADIOGRAFIA_49 = "https://buy.stripe.com/8x228q0Ll5635Rr3jReAg04";

export const BRAND = {
  name: "Enrique Torres",
  shortName: "Mr. ET",
  tagline: "IA aplicada a negocios reales",
};
